import * as React from 'react';

/** State with additional latests state
 *
 * see https://reactjs.org/docs/hooks-faq.html#why-am-i-seeing-stale-props-or-state-inside-my-function
 */
export function useLatestState<T>(
  value: T,
): [state: T, setState: (v: T) => void, latestState: React.MutableRefObject<T>] {
  const ref = React.useRef<T>(value);
  const [state, setState] = React.useState<T>(value);

  const setBoth = React.useCallback(
    (newValue: T) => {
      setState(newValue);
      ref.current = newValue;
    },
    [ref, setState],
  );

  return [state, setBoth, ref];
}
